import { useMemo } from 'react';
import type { FormField } from '@elfsight/widget-form-builder/widget';
import { getSiteURL } from '@elfsight/widget-utils';
import { useSettings } from '@wu/widget-core';

const submitMetadata = {
  type: 'calculator',
  webpage: decodeURIComponent(getSiteURL('page')),
  integrations: undefined
};

export function useEmailSubmitFormSettings(fields: FormField[]) {
  const {
    widgetToken,
    submitAction,
    submitRedirectURL,
    integrationSettingsID
  } = useSettings();

  return useMemo(
    () => ({
      submitAction,
      submitRedirectURL,
      integrationSettingsID,
      widgetToken,
      fields,
      submitAdditionalData: submitMetadata,
      webhooks: []
    }),
    [
      submitAction,
      submitRedirectURL,
      integrationSettingsID,
      widgetToken,
      fields
    ]
  );
}
